import { NavLink } from "react-router-dom";

const items = [
  { label: "首页", icon: "ri-home-5-line", to: "/" },
  { label: "电影", icon: "ri-film-line", to: "/category/movie" },
  { label: "电视剧", icon: "ri-tv-2-line", to: "/category/tv" },
  { label: "资讯", icon: "ri-newspaper-line", to: "/category/news" },
  { label: "搜索", icon: "ri-search-line", to: "/search" },
];

export default function MobileBottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary-800 border-t border-primary-900/60">
      <ul className="flex items-stretch">
        {items.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors ${
                  isActive ? "text-accent-400" : "text-primary-200"
                }`
              }
            >
              <i className={`${item.icon} text-xl`} />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}